// src/services/rapportService.js

import axios from 'axios';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getJournalStock = (params = {}) => {
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, value]) =>
            value !== undefined && value !== null && value !== ''
        )
    );
    return axios.get(`${DOMAIN}/api/rapport/journal-stock`, { params: clean });
};

// Pour la correction des réceptions
export const getCorrectionReceptionPreview = (idVarianteProduit) =>
    axios.get(`${DOMAIN}/api/produit/correction_reception/preview`, {
        params: { idVarianteProduit }
    });

export const postCorrectionReception = (idVarianteProduit, userId) =>
    axios.post(`${DOMAIN}/api/produit/correction_reception`, 
        { userId },
        { params: { idVarianteProduit } }
    );